import React from 'react';
import { useNavigate } from 'react-router-dom';
import { Button } from 'antd';
import config from '../../config';
import './sandbox.css';

/**
 * In place of the chat when the person's AI Foundry connection is off (usePlanFeatures) and they have no own model
 * key yet: the chat runs on their own key, so this asks for one, with the way to Features › Chat. A prompt, not an
 * error: nothing is broken, one step is missing.
 */
export default function OwnKeyPrompt() {
  const navigate = useNavigate();
  return (
    <div className="sbx-card sbx-own-key-prompt" role="region" aria-label="Add your model key">
      <strong>Add your model key to use Chat</strong>
      <span>
        Chat runs on your own model key while the AI Foundry connection is off. Add a key from your model provider
        (Anthropic, OpenAI, Gemini, Google Vertex AI or an OpenAI-compatible one); it is used only for your chats.
      </span>
      <Button onClick={() => navigate(config.sandboxFirst ? '/features/chat' : '/settings')} type="primary">
        Add your model key
      </Button>
    </div>
  );
}
